module.exports = __webpack_public_path__ + "static/media/sign-to-speech.54e07c13.svg";